import {
  dangerColor,
  whiteColor,
  secondaryColor
} from "@themes/defaultThemeProps";
import {
  cardTitle
} from "assets/jss/material-dashboard-pro-react.js";

import buttonGroupStyle from "assets/jss/material-dashboard-pro-react/buttonGroupStyle.js";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";
import hoverCardStyle from "assets/jss/material-dashboard-pro-react/hoverCardStyle.js";
import commonStyle from "assets/jss/material-dashboard-pro-react/commonStyle";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";

export const customFieldStyles = {
  ...commonStyle,
  ...hoverCardStyle,
  ...hoverCardStyle,
  ...customCheckboxRadioSwitch,
  functionName: {
    color: secondaryColor[2],
    fontWeight: "600",
    valign: "top"
  },
  functionDescription: {
    display: "block",
    color: secondaryColor[0],
    fontWeight: "300"
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  formCategory: {
    marginBottom: "0",
    color: secondaryColor[0],
    fontSize: "14px",
    padding: "10px 0 10px"
  },
  center: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center"
  },
  registerButton: {
    float: "right"
  },
  leftButton: {
    float: "left"
  },
  danger: {
    color: dangerColor[0] + "!important"
  },
// from extended table style
  ...buttonGroupStyle,
  right: {
    textAlign: "right"
  },
  description: {
    maxWidth: "150px"
  },
  actionButton: {
    margin: "0 0 0 5px",
    padding: "5px",
    "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      marginRight: "0px"
    }
  },
  icon: {
    verticalAlign: "middle",
    width: "17px",
    height: "17px",
    top: "-1px",
    position: "relative"
  },
  imgContainer: {
    width: "120px",
    maxHeight: "160px",
    overflow: "hidden",
    display: "block"
  },
  img: {
    width: "100%",
    height: "auto",
    verticalAlign: "middle",
    border: "0"
  },
  tdName: {
    minWidth: "200px",
    fontWeight: "400",
    fontSize: "1.5em"
  },
  tdNameAnchor: {
    color: secondaryColor[2]
  },
  tdNameSmall: {
    color: secondaryColor[0],
    fontSize: "0.75em",
    fontWeight: "300"
  },
  tdNumber: {
    textAlign: "right",
    minWidth: "145px",
    fontWeight: "300",
    fontSize: "1.3em !important"
  },
  tdNumberSmall: {
    marginRight: "3px"
  },
  tdNumberAndButtonGroup: {
    lineHeight: "1 !important"
  },
  positionAbsolute: {
    position: "absolute",
    right: "0",
    top: "0"
  },
  customFont: {
    fontSize: "16px !important"
  },
  actionButtonRound: {
    width: "auto",
    height: "auto",
    minWidth: "auto"
  },
  parameterName: {
    color: secondaryColor[2],
    fontWeight: "600",
    valign: "top"
  },
  parameterDescription: {
    display: "block",
    color: secondaryColor[0],
    fontWeight: "300"
  },
  errorNoProjectKeysMsg: {
    color: "red",
    marginTop: "-10px",
    fontSize: '16px',
    alignItems: 'center',
    "& .item": {
      marginRight: '5px',
      fontStyle: "italic",
      fontWeight: "400"
    },
    "& b": {
      marginRight: '5px'
    },
    "& #title": {
      display: "flex",
      marginBottom: -15,
      "& span": {
        marginRight: '5px'
      }
    }
  },
  productAttributesCard: {
    marginTop: "50px"
  },
  customFieldsCard: {
    marginTop: "25px"
  },
  customFieldsCardBody: {
    backgroundColor: "re",
    padding: '50px'
  },
  tableHeaderText: {
    marginBottom: -15,
    fontSize: "16px",
    fontWeight: "600",
  },
  noResultsBox: {
    textAlign: "center",
    width: "100%",
    marginTop: "50px",
    marginBottom: "50px",
  },
  fieldContainerWarnErrors: {
    textAlign: "left",
    marginTop: "30px",
    marginBottom: "30px",
    fontSize: "14px",
    "& div": {
      marginTop: "5px"
    }
  }

}
